import { useSessionAuth } from '@/context/Auth';
import { markAllNotificationsAsRead } from '@/infrastructure/api/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useMarkAllAsRead = () => {
  const { token } = useSessionAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      if (!token) throw new Error('No token available');
      return await markAllNotificationsAsRead(token);
    },
    onSuccess: () => {
      // Invalidate and refetch notification queries
      queryClient.invalidateQueries({
        queryKey: ['notifications'],
      });
      queryClient.invalidateQueries({
        queryKey: ['notifications', 'unread-count'],
      });
    },
  });
};
